import { NotificationDto } from '../services/api/sharedTypes/Notification'

export const getEmptyNotificationObject: () => NotificationDto = () => {
    return {
        date: new Date(),
        note: '',
    }
}
